const user_vars = [
    { variable: "{api_key}", description: "API ключ пользователя" },
    { variable: "{name}", description: "Имя пользователя" },
    { variable: "{second_name}", description: "Отчество пользователя" },
    { variable: "{surname}", description: "Фамилия пользователя" },
    { variable: "{phone}", description: "Телефон пользователя" },
    { variable: "{email}", description: "Email пользователя" },
    { variable: "{credit_score}", description: "Кредитный рейтинг пользователя" },
];

const offer_vars = [
    { variable: "{affiliate_url}", description: "Длинная ссылка" },
    { variable: "{short_url}", description: "Короткая ссылка" },
    { variable: "{offer_name}", description: "Название оффера" },
    { variable: "{offer_description}", description: "Описание оффера" },
    { variable: "{offer_bet}", description: "Ставка оффера" },
    { variable: "{offer_days}", description: "Сумма займа" },
    { variable: "{offer_rate}", description: "Рейтинг оффера" },
];

const autoreg_vars = [{ variable: "{autoreg_url}", description: "Ссылка на авторегу" }];

const showcase_vars = [{ variable: "{showcase_url}", description: "Ссылка на витрину" }];

const code_vars = [
    { variable: "{sms_code}", description: "Код для СМС" },
    { variable: "{email_code}", description: "Код для Email" },
];

const variable = {
    user: user_vars,
    offer: offer_vars,
    showcase: showcase_vars,
    code: code_vars,
};

export default {
    get() {
        return user_vars.concat(offer_vars, autoreg_vars, showcase_vars, code_vars);
    },
    getByContent(content) {
        switch (content) {
            case "offer":
                return user_vars.concat(offer_vars);
            case "showcase":
                return user_vars.concat(showcase_vars);
            case "code":
                return user_vars.concat(code_vars);
            default:
                return user_vars;
        }
    },
    getByType(type) {
        return variable.hasOwnProperty(type) ? variable[type] : [];
    },
};
